import 'react-bootstrap-typeahead/css/Typeahead.css';
import { Sector } from "../../Business/dto/Brief";
import { ExternalDataPicker } from "./ExternalDataPicker";
import { DataKey } from '../../Business/dto/ExternalSystemElement';
import { faTag } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';

export interface SectorPickerProps {
    setSelectedSector: (sector: Sector | undefined) => void;
    required?: boolean;
    value: Sector | undefined;
}

export const SectorPicker = (props: SectorPickerProps) => {
    const { t } = useTranslation();

    return (
        <>
            {
                <ExternalDataPicker
                    setSelectedData={props.setSelectedSector}
                    placeholder={t("txt_sector")}
                    dataKey={DataKey.Sector}
                    displayCode
                    icon={faTag}
                    controlId="sectorPicker"
                    required={props.required}
                    value={props.value ? [props.value] : []}
                />
            }
        </>
    );
}